module.exports = __webpack_public_path__ + "img/Frame 1321315181@2x.4277ae7d.png";